import { getCount } from "./base";
import { OFFER_TYPES } from "../constants/offerTypes";

const phoneOfferCountPath = "/portal/api/phone_offers/count";
const propositionCountPath = "/portal/api/propositions/count";

const getOfferTypeCount = (clientConfig, offerType, dataStatus) => {
  switch (offerType) {
    case OFFER_TYPES.phoneOffer:
      return getCount(clientConfig, dataStatus, phoneOfferCountPath);
    case OFFER_TYPES.proposition:
      return getCount(clientConfig, dataStatus, propositionCountPath, {
        isSimOnly: false
      });
    case OFFER_TYPES.simOnly:
      return getCount(clientConfig, dataStatus, propositionCountPath, {
        isSimOnly: true
      });
    default:
      return null;
  }
};

export { getOfferTypeCount };
